// import Phaser from 'phaser'
import Config from '../launch/config'
import {isDebug} from '../launch/utils'
import {handleTowableClick} from '../app/app'

export default function handleTowablePointerDown(worldX, worldY) {
    const towableBodies = Config.scene.matter
        .getMatterBodies()
        .filter((body) => {
            const customProps = body[Config.namespace]

            if (!customProps) {
                return false
            }

            if (!customProps.isTowableBody) {
                return false
            }

            return true
        })

    // https://photonstorm.github.io/phaser3-docs/Phaser.Physics.Matter.MatterPhysics.html
    const undiscoveredClickArea = 28
    const undiscoveredIntersection = Config.scene.matter.intersectRect(
        worldX - undiscoveredClickArea / 2,
        worldY - undiscoveredClickArea / 2,
        undiscoveredClickArea,
        undiscoveredClickArea,
        false,
        towableBodies
    )
    const actualClickArea = 1
    const actualIntersection = Config.scene.matter.intersectRect(
        worldX - actualClickArea / 2,
        worldY - actualClickArea / 2,
        actualClickArea,
        actualClickArea,
        false,
        towableBodies
    )
    const intersection = undiscoveredIntersection.length
        ? undiscoveredIntersection
        : actualIntersection

    if (intersection.length) {
        const id = intersection[0][Config.namespace].towableId
        const towable = Config.towables[id]

        if (
            towable.isDiscovered &&
            undiscoveredIntersection.length &&
            !actualIntersection.length
        ) {
            return
        }

        isDebug && console.log(towable)

        if (towable.towShipId) {
            Config.ships[towable.towShipId].selected = false
            delete Config.selectedShips[towable.towShipId]
        }

        if (Object.keys(Config.selectedShips).length) {
            return
        }

        if (towable.isSelected) {
            towable.isSelected = false
            Config.selectedTowableId = null
            handleTowableClick(null, true)
            return
        }

        Config.selectedTowableId = id
        towable.isSelected = true
        handleTowableClick(towable)
    } else if (Config.selectedTowableId) {
        const towable = Config.towables[Config.selectedTowableId]

        towable.isSelected = false
        Config.selectedTowableId = null
        handleTowableClick(null, true)
    }
}
